import { ChevronLeft, Send } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import ChatBubble from "@/components/ui/chat-bubble";
import { cn } from "@/lib/utils";

type Props = {
    name: string;
    avatar: string;
    welcomeMessage: string;
    widgetColor: string;
    isLoading: boolean;
};

const ChatPreview: React.FC<Props> = ({ name, avatar, welcomeMessage, widgetColor }) => {
    return (
        <Card className="p-4 text-gray-600 shadow-none">
            {/* <Card className="flex items-center gap-4  bg-gray-200 p-2 text-gray-600 shadow-none">
                {isLoading ? (
                    <Skeleton className="h-10 w-24" />
                ) : (
                    <Button className="bg-white text-gray-600 shadow-md" variant={"secondary"}>
                        Chat Bubble
                    </Button>
                )}
                {isLoading ? (
                    <Skeleton className="h-10 w-36" />
                ) : (
                    <Button className="bg-white text-gray-600 shadow-md" variant={"secondary"}>
                        Lead Collection Popup
                    </Button>
                )}
            </Card> */}
            <Card title="" className="mx-auto mt-4 min-h-[550px] md:max-w-[calc(100%-200px)] border-none p-0 text-white shadow-none">
                <div
                    style={{ backgroundColor: widgetColor || "#96cef3" }}
                    className={cn("flex items-center justify-between gap-2 rounded-t-md p-2 text-white")}
                >
                    <Button size={"sm"} className="bg-white" style={{ color: widgetColor || "#96cef3" }}>
                        <ChevronLeft className="size-6" />
                    </Button>
                    <div className="flex items-center gap-1">
                        <p className="mr-2 font-bold">{name ?? "Shoe Einstein"}</p>
                        <img src={avatar ?? "/assets/images/logo/bot-icon.png"} alt="bot-avatar" className="size-6 bg-white p-1 rounded-full" />
                    </div>
                </div>
                <div className="relative rounded-b-lg border-x border-b p-4">
                    <div className="mb-20 h-[400px] overflow-y-auto scroll-smooth">
                        <div className="w-full p-4">
                            <ul className="space-y-3">
                                <li>
                                    <ChatBubble messageFrom="bot" orientation="left">
                                        {welcomeMessage ??
                                            "Hi, I am Shoe Einstein. An AI-based chat assistant to help you with your query. I am available 24/7 for your assistance."}
                                    </ChatBubble>
                                </li>
                                <li>
                                    <ChatBubble orientation="right" backgroundColor={widgetColor}>
                                        Can you tell me about your refund policy?
                                    </ChatBubble>
                                </li>
                                <li>
                                    <ChatBubble messageFrom="bot" orientation="left">
                                        Sure, here is our refund policy. If you are unsatisfied with your purchase, you may return it for a full
                                        refund within 3 days of purchase, provided the item is in its original condition with all tags attached.
                                    </ChatBubble>
                                </li>
                                <li>
                                    <ChatBubble messageFrom="bot" orientation="left">
                                        Is there anything else, I can help you with today?
                                    </ChatBubble>
                                </li>
                                <li>
                                    <ChatBubble orientation="right" messageFrom="user" backgroundColor={widgetColor}>
                                        Yes, do you have any casual shoes available in brown color that goes well with blue jeans?
                                    </ChatBubble>
                                </li>
                                <li>
                                    <ChatBubble messageFrom="bot" orientation="left">
                                        I think, you can try out cool brown boots for jeans
                                    </ChatBubble>
                                </li>
                                <li>
                                    <ChatBubble orientation="right" messageFrom="user" backgroundColor={widgetColor}>
                                        What would be price range for those boots?
                                    </ChatBubble>
                                </li>
                                <li>
                                    <ChatBubble messageFrom="bot" orientation="left">
                                        These boots are available for $49.99 only.
                                    </ChatBubble>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="absolute bottom-0 left-0 w-full rounded-b-xl border-t bg-white p-4">
                        <input
                            type="text"
                            placeholder="Type a message..."
                            className="h-12 w-full rounded-xl border border-none bg-blue-100 px-4 pr-14 outline-none"
                        />
                        <button className="absolute right-6 top-1/2 -translate-y-1/2 rounded-full bg-blue-500 p-2 font-semibold text-white">
                            <Send className="size-4" />
                        </button>
                    </div>
                </div>
            </Card>
        </Card>
    );
};

export default ChatPreview;
